// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPublicationCard-cls1_Jzv","cls2":"EvaluationPublicationCard-cls2_DYL EvaluationPublicationCard-cls1_Jzv"};